import { MapElementMixin, gmapApi } from "vue2-google-maps";

export default {
	name: "KTrucksMapTrafficLayer",

	inject: [ "storeModuleName" ],

	mixins: [ MapElementMixin ],

	data: () => ( {
		trafficLayer: null
	} ),

	computed: {
		google: gmapApi,

		visible() {
			return this.$store.state[this.storeModuleName].traffic;
		}
	},

	watch: {
		visible( val ) {
			if ( this.trafficLayer ) {
				this.trafficLayer.setMap( val ? this.$map : null );
			}
		}
	},

	created() {
		this.$mapPromise.then( () => {
			this.trafficLayer = new this.google.maps.TrafficLayer();
			this.trafficLayer.setMap( this.visible ? this.$map : null );
		} );
	},
	destroyed() {
		this.trafficLayer.setMap( null );
	},

	render() {
		return null;
	}
};
